import "./App.css";
import io from "socket.io-client";
import { useEffect, useState } from "react";
import Chat from "./Chat";
import Auth from "./Auth";
import axios from "axios";

// Define API URL
const API_URL =
  process.env.NODE_ENV === "production"
    ? "https://realtimechat-07z5.onrender.com"
    : "http://localhost:3001";

// Define Socket
const SOCKET_URL =
  process.env.NODE_ENV === "production"
    ? "https://realtimechat-07z5.onrender.com"
    : "http://localhost:3001";

const socket = io.connect(SOCKET_URL);

function App() {
  const [theme, setTheme] = useState("dark");
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [username, setUsername] = useState("");

  // Room State
  const [room, setRoom] = useState("");
  const [roomPassword, setRoomPassword] = useState("");
  const [showChat, setShowChat] = useState(false);
  const [error, setError] = useState("");

  // Toggle between "Join" and "Create" tabs
  const [activeTab, setActiveTab] = useState("join"); // 'join' or 'create'

  useEffect(() => {
    document.body.className = theme;
  }, [theme]);

  const toggleTheme = () => {
    setTheme((curr) => (curr === "light" ? "dark" : "light"));
  };

  // Called when Auth component reports a successful login
  const handleLogin = (user) => {
    setUsername(user);
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    setIsAuthenticated(false);
    setShowChat(false);
    setUsername("");
    setRoom("");
  };

  // Function to Join an existing room
  const joinRoom = async () => {
    if (room === "") return;
    setError("");

    try {
      // Verify with Backend first
      await axios.post(`${API_URL}/join-room`, {
        roomName: room,
        password: roomPassword,
      });

      // If backend says OK, connect via Socket
      socket.emit("join_room", room);
      setShowChat(true);
    } catch (err) {
      setError(err.response?.data?.message || "Failed to join room");
    }
  };

  // Function to Create a new room
  const createRoom = async () => {
    if (room === "") return;
    setError("");

    try {
      await axios.post(`${API_URL}/create-room`, {
        roomName: room,
        password: roomPassword,
        creator: username,
      });

      alert("Room created! You can now join.");
      setActiveTab("join"); // Switch back to join tab
    } catch (err) {
      setError(err.response?.data?.message || "Failed to create room");
    }
  };

  return (
    <div className="App">
      {/* --- NEW: Top Navigation Bar --- */}
      <nav className="navbar">
        <div className="logo">Chat App</div>
        <div className="nav-actions">
          {isAuthenticated && (
            <span className="user-greeting">
              Hi, <b>{username}</b>
            </span>
          )}
          {isAuthenticated && (
            <button className="nav-btn" onClick={handleLogout}>
              Logout
            </button>
          )}
          <button className="nav-btn theme-btn" onClick={toggleTheme}>
            {theme === "light" ? "🌙" : "☀️"}
          </button>
        </div>
      </nav>

      {/* --- Main Content Area --- */}
      <div className="main-content">
        {!isAuthenticated ? (
          <Auth onLogin={handleLogin} />
        ) : (
          <>
            {!showChat ? (
              <div className="joinChatContainer">
                <h3>Welcome, {username}!</h3>

                {/* TABS */}
                <div className="tab-container">
                  <button
                    className={activeTab === "join" ? "tab active" : "tab"}
                    onClick={() => {
                      setActiveTab("join");
                      setError("");
                    }}
                  >
                    Join Room
                  </button>
                  <button
                    className={activeTab === "create" ? "tab active" : "tab"}
                    onClick={() => {
                      setActiveTab("create");
                      setError("");
                    }}
                  >
                    Create Room
                  </button>
                </div>

                {/* FORM */}
                <div className="form-container">
                  <input
                    type="text"
                    placeholder="Room Name..."
                    onChange={(event) => setRoom(event.target.value)}
                  />
                  <input
                    type="password"
                    placeholder={
                      activeTab === "create"
                        ? "Password (Optional)..."
                        : "Password..."
                    }
                    onChange={(event) => setRoomPassword(event.target.value)}
                    onKeyPress={(event) => {
                      if (event.key === "Enter") {
                        activeTab === "join" ? joinRoom() : createRoom();
                      }
                    }}
                  />

                  {error && <p className="error-text">{error}</p>}

                  <button
                    onClick={activeTab === "join" ? joinRoom : createRoom}
                  >
                    {activeTab === "join" ? "Enter Room" : "Create Room"}
                  </button>
                </div>
              </div>
            ) : (
              <Chat socket={socket} username={username} room={room} />
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default App;
